"use strict";

(function () {
  var adpPopup = {};
  var sPrevious = window.scrollY;
  var sDirection = 'down';
  var $this = adpPopup;

  adpPopup.init = function () {
    $this.popupInit();
    $this.events();
  };

  adpPopup.events = function () {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.popup-close')) $this.closePopup(e.target.closest('.popup-close'));
      if (e.target.closest('.popup-accept')) {
        $this.acceptPopup(e.target.closest('.popup-accept'));
        $this.closePopup(e.target.closest('.popup-accept'));
      }
      if (e.target.closest('.age-verification__popup-close')) {
        $this.agePopup(e.target.closest('.age-verification__popup-close'));
        $this.closePopup(e.target.closest('.age-verification__popup-close'));
      }
      if (e.target.closest('.age-verification__button-no')) $this.ageDeclined();
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (popup) { $this.closePopup(popup); });
      }
      if (e.key === 'F4') {
        document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (popup) { $this.closePopup(popup); });
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.popup-overlay')) {
        document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function (popup) { $this.closePopup(popup); });
      }
    });
  };

  adpPopup.popupInit = function () {
    document.addEventListener('scroll', function () {
      var scrollCurrent = window.scrollY;
      sDirection = scrollCurrent > sPrevious ? 'down' : 'up';
      sPrevious = scrollCurrent;
    });

    document.querySelectorAll('.popup').forEach(function (popup) {
      if (popup.getAttribute('data-open-trigger') === 'manual') {
        var selector = popup.getAttribute('data-open-manual-selector');
        if (selector) {
          document.querySelectorAll(selector).forEach(function (el) { el.classList.add('popup-trigger'); });
          document.addEventListener('click', function (e) {
            var target = e.target.closest(selector);
            if (!target) return;
            e.preventDefault();
            popup.classList.remove('popup-already-opened');
            $this.openPopup(popup);
            if (e.currentTarget && e.currentTarget.closest && e.currentTarget.closest('.popup')) {
              $this.closePopup(target);
            }
          });
        }
      }

      if (!$this.isAllowPopup(popup) && !popup.classList.contains('age-verification')) return;
      $this.openTriggerPopup(popup);
    });
  };

  adpPopup.openTriggerPopup = function (popup) {
    var trigger = popup.getAttribute('data-open-trigger');
    if (trigger === 'none') {
      var ageVerification = $this.getStorage('popup-age-' + (popup.getAttribute('data-id') || 0));
      if (!ageVerification) $this.openPopup(popup);
    }
    if (trigger === 'delay') {
      setTimeout(function () { $this.openPopup(popup); }, parseInt(popup.getAttribute('data-open-delay-number')) * 1000);
    }
    if (trigger === 'exit') {
      var showExit = true;
      document.addEventListener('mousemove', function (e) {
        var scroll = window.pageYOffset || document.documentElement.scrollTop;
        if ((e.pageY - scroll) < 7 && showExit) { $this.openPopup(popup); showExit = false; }
      });
    }
    if (trigger === 'scroll') {
      var pointScrollType = popup.getAttribute('data-open-scroll-type');
      var pointScrollPosition = parseInt(popup.getAttribute('data-open-scroll-position'));
      document.addEventListener('scroll', function () {
        if (pointScrollType === 'px' && window.scrollY >= pointScrollPosition) $this.openPopup(popup);
        if (pointScrollType === '%' && $this.getScrollPercent() >= pointScrollPosition) $this.openPopup(popup);
      });
    }
    if (trigger === 'accept') {
      var accept = $this.getStorage('popup-accept-' + (popup.getAttribute('data-id') || 0));
      if (!accept) $this.openPopup(popup);
    }
  };

  adpPopup.closeTriggerPopup = function (popup) {
    var trigger = popup.getAttribute('data-close-trigger');
    if (trigger === 'delay') {
      setTimeout(function () { $this.closePopup(popup); }, parseInt(popup.getAttribute('data-close-delay-number')) * 1000);
    }
    if (trigger === 'scroll') {
      var pointScrollType = popup.getAttribute('data-close-scroll-type');
      var pointScrollPosition = parseInt(popup.getAttribute('data-close-scroll-position'));
      var initScrollPx = parseInt(popup.getAttribute('data-init-scroll-px'));
      var initScrollPercent = parseInt(popup.getAttribute('data-init-scroll-percent'));

      document.addEventListener('scroll', function () {
        if (pointScrollType === 'px') {
          if (sDirection === 'up' && window.scrollY < (initScrollPx - pointScrollPosition)) $this.closePopup(popup);
          if (sDirection === 'down' && window.scrollY >= (initScrollPx + pointScrollPosition)) $this.closePopup(popup);
        }
        if (pointScrollType === '%') {
          if (sDirection === 'up' && $this.getScrollPercent() < (initScrollPercent - pointScrollPosition)) $this.closePopup(popup);
          if (sDirection === 'down' && $this.getScrollPercent() >= (initScrollPercent + pointScrollPosition)) $this.closePopup(popup);
        }
      });
    }
  };

  adpPopup.openPopup = function (popup) {
    if (popup.classList.contains('popup-open') || popup.classList.contains('popup-already-opened')) return;

    if (popup.getAttribute('data-body-scroll-disable') === 'true') {
      document.body.classList.add('popup-scroll-hidden');
    }

    var limit = parseInt($this.getStorage('popup-' + popup.getAttribute('data-id')) || 0) + 1;
    $this.setStorage('popup-' + popup.getAttribute('data-id'), limit, { expires: popup.getAttribute('data-limit-lifetime') });

    popup.classList.add('popup-open');
    popup.setAttribute('data-init-scroll-px', window.scrollY);
    popup.setAttribute('data-init-scroll-percent', $this.getScrollPercent());

    var animation = popup.getAttribute('data-open-animation');
    $this.applyAnimation(popup, animation);
    $this.closeTriggerPopup(popup);
  };

  adpPopup.agePopup = function (el) {
    var popup = el.closest('.popup');
    if (popup) {
      $this.setStorage('popup-age-' + popup.getAttribute('data-id'), 1, { expires: 360 });
    }
  };

  adpPopup.ageDeclined = function () {
    var question = document.querySelector('.age-verification__question');
    var declined = document.querySelector('.age-verification__declined');
    if (question) question.classList.remove('show');
    if (declined) declined.classList.add('show');
  };

  adpPopup.acceptPopup = function (el) {
    var popup = el.closest('.popup');
    if (popup) {
      $this.setStorage('popup-accept-' + popup.getAttribute('data-id'), 1, { expires: 360 });
    }
  };

  adpPopup.closePopup = function (el) {
    var popup = el.closest('.popup');
    if (!popup) return;
    var animation = popup.getAttribute('data-exit-animation');
    $this.applyAnimation(popup, animation, function () {
      popup.classList.add('popup-already-opened');
      popup.classList.remove('popup-open');
    });
    document.body.classList.remove('popup-scroll-hidden');
  };

  adpPopup.isAllowPopup = function (popup) {
    var limitDisplay = parseInt(popup.getAttribute('data-limit-display') || 0);
    var limitDisplayCookie = parseInt($this.getStorage('popup-' + popup.getAttribute('data-id')));
    if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) return false;
    return true;
  };

  adpPopup.applyAnimation = function (el, name, callback) {
    var popup = el.closest('.popup');
    if (!popup) return;
    var overlayName = typeof callback === 'function' ? 'popupExitFade' : 'popupOpenFade';

    var overlay = popup.nextElementSibling;
    if (overlay && overlay.classList.contains('popup-overlay')) {
      overlay.classList.add('popup-animated', overlayName);
      var onOverlayEnd = function () {
        overlay.classList.remove('popup-animated', overlayName);
        overlay.removeEventListener('animationend', onOverlayEnd);
      };
      overlay.addEventListener('animationend', onOverlayEnd);
    }

    var wrap = popup.querySelector('.popup-wrap');
    if (wrap) {
      wrap.classList.add('popup-animated', name);
      var onWrapEnd = function () {
        wrap.classList.remove('popup-animated', name);
        wrap.removeEventListener('animationend', onWrapEnd);
        if (typeof callback === 'function') callback();
      };
      wrap.addEventListener('animationend', onWrapEnd);
    }
  };

  adpPopup.getCookie = function (name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  adpPopup.setCookie = function (name, value, options) {
    options = options || {};
    options.path = options.hasOwnProperty('path') ? options.path : '/';
    options.expires = parseInt(options.expires);
    if (typeof options.expires === "number" && options.expires) {
      options.expires = new Date(new Date().setDate(new Date().getDate() + options.expires)).toUTCString();
    }
    value = encodeURIComponent(value);
    var updatedCookie = name + "=" + value;
    for (var propName in options) {
      updatedCookie += "; " + propName;
      var propValue = options[propName];
      if (propValue !== true) updatedCookie += "=" + propValue;
    }
    document.cookie = updatedCookie;
  };

  adpPopup.getStorage = function (key) {
    var item = localStorage.getItem(key);
    if (!item) return undefined;
    try {
      var parsed = JSON.parse(item);
      if (parsed.expires && Date.now() > parsed.expires) { localStorage.removeItem(key); return undefined; }
      return parsed.value;
    } catch (e) { return undefined; }
  };

  adpPopup.setStorage = function (key, value, options) {
    options = options || {};
    var data = { value: value, expires: null };
    if (options.expires) {
      var expiresDate = new Date();
      expiresDate.setDate(expiresDate.getDate() + parseInt(options.expires, 10));
      data.expires = expiresDate.getTime();
    }
    localStorage.setItem(key, JSON.stringify(data));
  };

  adpPopup.getScrollPercent = function () {
    var h = document.documentElement, b = document.body;
    return (h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight) * 100;
  };

  adpPopup.init();

  document.addEventListener('shopify:section:load', function () { adpPopup.init(); });
  document.addEventListener('shopify:section:unload', function () { document.body.classList.remove('popup-scroll-hidden'); });
})();
